import { withStyles, WithStyles } from "@mui/styles";
import styles from "assets/jss/mui-extras/imageStyle";
import classNames from "classnames";
import * as React from "react";

export type MuiImageOrientation = "wide" | "portrait" | "square";
export type MuiImageSize = "sm" | "xs" | "icon" | "auto";

interface IProps {
    rounded?: boolean;
    orientation?: MuiImageOrientation;
    size?: MuiImageSize;
}

type Props = IProps & WithStyles<typeof styles> & React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;

const MuiImage: React.FC<Props> = (props) => {
    const {
        classes,
        rounded,
        orientation,
        size,
        className,
        alt,
        ...rest
    } = props;

    const compClasses = classNames({
        [classes.rounded]: rounded,
        [classes[orientation]]: orientation !== undefined,
        [size]: size,
        [className]: className
    });

    return (<img {...rest} className={compClasses} alt={alt} />);
};

MuiImage.defaultProps = {
    rounded: false,
    orientation: "wide"
};

export default withStyles(styles)(MuiImage);
